/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import { SpinnerDotted } from 'spinners-react';
import { LOADER_COLOR, LOADER_SIZE } from '../../constants/loaderConstants';
// import actimg from '../../assets/act_img.png';
import actimg0 from '../../assets/actimg0.png';
import DEFAULT_EVENT_IMAGE_URL from '../../constants/imageConstants';
import { REACT_APP_API_FETCH_SHOWS } from '../../redux/apiConstants';
import { getCookies } from '../../hooks/useCookies';
import { formatEventDateTz, formatEventTime } from '../../utilityFunctions/utilsFunctions';
import noEvent from '../../assets/no_events.png';

function ShowCard() {
  const [loading, setLoading] = useState(false);
  const [event, setEvent] = useState(false);
  const navigate = useNavigate();
  let response;
  let statusCode;
  const token = `Bearer ${getCookies('Token')}`;
  const getShows = async () => {
    setLoading(true);
    axios
      .get(REACT_APP_API_FETCH_SHOWS, {
        method: 'GET',
        headers: { Authorization: token },
      })
      .then((resp) => {
        setLoading(false);
        statusCode = resp?.status;
        return resp;
      })
      .then((res) => {
        if (statusCode === 200) {
          setLoading(false);
          response = res?.data?.data?.result;
          setEvent(response?.results);
          // setEvent([]);
        }
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };
  useEffect(() => {
    getShows();
  }, []);
  return (
    <div>
      <div className="active_show_outer">
        <div className="col-md-12">
          <h2>All Shows</h2>
          {loading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
              }}
            >
              <SpinnerDotted size={LOADER_SIZE} color={LOADER_COLOR} />
            </div>
          ) : (
            <div className="show_box_main">
              {event && event.length > 0 ? (
                <div className="showbox_sec">
                  {event.map((item) => (
                    <div
                      className="show_box"
                      onClick={() => navigate(`/shows/view-users/${item.id}`)}
                    >
                      <div className="active_show_inner">
                        <div className="act_box_img">
                          <Image src={item.image ? item.image : DEFAULT_EVENT_IMAGE_URL} alt="" />
                        </div>
                        <div className="act_box_cnt">
                          <div className="act_box_bdg">
                            <span
                              className={`${
                                item.bookingStatus === 'sold-out' || item.status === 'ended'
                                  ? 'sold'
                                  : ''
                              }`}
                            >
                              {item.bookingStatus === 'sold-out'
                                ? 'Sold-out'
                                : item.status === 'created'
                                ? 'Upcoming'
                                : item.status === 'in progress'
                                ? 'Ongoing'
                                : 'Ended'}
                            </span>
                          </div>
                          <h3>{item.eventName}</h3>
                          <p>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="19"
                              viewBox="0 0 18 19"
                              fill="none"
                            >
                              <path
                                d="M9 16.9762C13.1421 16.9762 16.5 15.4652 16.5 13.6012C16.5 12.6513 15.6278 11.7929 14.2241 11.1796C13.3675 12.7515 12.0613 14.1064 10.4021 14.8154C9.51032 15.1965 8.48968 15.1965 7.59786 14.8154C5.93871 14.1064 4.6325 12.7515 3.77594 11.1796C2.37221 11.7929 1.5 12.6513 1.5 13.6012C1.5 15.4652 4.85786 16.9762 9 16.9762Z"
                                fill="#132941"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M3.75 6.86199C3.75 4.16354 6.10051 1.97601 9 1.97601C11.8995 1.97601 14.25 4.16354 14.25 6.86199C14.25 9.53929 12.5744 12.6635 9.96005 13.7807C9.35061 14.0411 8.64939 14.0411 8.03995 13.7807C5.42562 12.6635 3.75 9.53929 3.75 6.86199ZM9 8.72601C9.82843 8.72601 10.5 8.05444 10.5 7.22601C10.5 6.39759 9.82843 5.72601 9 5.72601C8.17157 5.72601 7.5 6.39759 7.5 7.22601C7.5 8.05444 8.17157 8.72601 9 8.72601Z"
                                fill="#132941"
                              />
                            </svg>
                            <span>
                              {item.onlineDetails?.platform || item.onlineDetails?.streamingUrl
                                ? `Online${
                                    item.onlineDetails?.platform
                                      ? ` • ${item.onlineDetails.platform}`
                                      : ' • Streaming'
                                  }`
                                : [
                                    item.location?.venue,
                                    item.location?.city,
                                    item.location?.country,
                                  ]
                                    .filter(Boolean)
                                    .join(', ') || 'Location'}
                            </span>
                          </p>
                          <p>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="19"
                              viewBox="0 0 18 19"
                              fill="none"
                            >
                              <path
                                d="M5.8125 2.35101C5.8125 2.04035 5.56066 1.78851 5.25 1.78851C4.93934 1.78851 4.6875 2.04035 4.6875 2.35101V3.53546C3.608 3.6219 2.89933 3.83404 2.37868 4.35469C1.85803 4.87534 1.64588 5.58402 1.55944 6.66351H16.4406C16.3541 5.58402 16.142 4.87534 15.6213 4.35469C15.1007 3.83404 14.392 3.6219 13.3125 3.53546V2.35101C13.3125 2.04035 13.0607 1.78851 12.75 1.78851C12.4393 1.78851 12.1875 2.04035 12.1875 2.35101V3.48569C11.6886 3.47601 11.1293 3.47601 10.5 3.47601H7.5C6.87072 3.47601 6.31145 3.47601 5.8125 3.48569V2.35101Z"
                                fill="#132941"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M1.5 9.47601C1.5 8.84674 1.5 8.28746 1.50968 7.78851H16.4903C16.5 8.28746 16.5 8.84674 16.5 9.47601V10.976C16.5 13.8044 16.5 15.2187 15.6213 16.0973C14.7426 16.976 13.3284 16.976 10.5 16.976H7.5C4.67157 16.976 3.25736 16.976 2.37868 16.0973C1.5 15.2187 1.5 13.8044 1.5 10.976V9.47601ZM12.75 10.976C13.1642 10.976 13.5 10.6402 13.5 10.226C13.5 9.8118 13.1642 9.47601 12.75 9.47601C12.3358 9.47601 12 9.8118 12 10.226C12 10.6402 12.3358 10.976 12.75 10.976ZM12.75 13.976C13.1642 13.976 13.5 13.6402 13.5 13.226C13.5 12.8118 13.1642 12.476 12.75 12.476C12.3358 12.476 12 12.8118 12 13.226C12 13.6402 12.3358 13.976 12.75 13.976ZM9.75 10.226C9.75 10.6402 9.41421 10.976 9 10.976C8.58579 10.976 8.25 10.6402 8.25 10.226C8.25 9.8118 8.58579 9.47601 9 9.47601C9.41421 9.47601 9.75 9.8118 9.75 10.226ZM9.75 13.226C9.75 13.6402 9.41421 13.976 9 13.976C8.58579 13.976 8.25 13.6402 8.25 13.226C8.25 12.8118 8.58579 12.476 9 12.476C9.41421 12.476 9.75 12.8118 9.75 13.226ZM5.25 10.976C5.66421 10.976 6 10.6402 6 10.226C6 9.8118 5.66421 9.47601 5.25 9.47601C4.83579 9.47601 4.5 9.8118 4.5 10.226C4.5 10.6402 4.83579 10.976 5.25 10.976ZM5.25 13.976C5.66421 13.976 6 13.6402 6 13.226C6 12.8118 5.66421 12.476 5.25 12.476C4.83579 12.476 4.5 12.8118 4.5 13.226C4.5 13.6402 4.83579 13.976 5.25 13.976Z"
                                fill="#132941"
                              />
                            </svg>
                            <span>
                              {formatEventDateTz(
                                item?.startDate,
                                item?.timezone || item?.timezoneCode
                              )}{' '}
                              |{' '}
                              {formatEventTime(
                                item.startTime,
                                item?.timezone || item?.timezoneCode
                              )}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="no_show_box">
                  <Image src={noEvent} alt="gggf" />
                  <h6>There is no active event.</h6>
                </div>
              )}

              {/* <div className="show_box">
            <div className="active_show_inner">
            <div className="act_box_img">
            <Image src={actimg0} alt="" />
            </div>
            <div className="act_box_cnt">
            <div className="act_box_bdg">
            <span className="sold">Sold Out</span>
            </div>
            <h3>Shaan Rahman USA & Canada Tour</h3>
            <p>
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
            >
            <path
            d="M9 16.9762C13.1421 16.9762 16.5 15.4652 16.5 13.6012C16.5 12.6513 15.6278 11.7929 14.2241 11.1796C13.3675 12.7515 12.0613 14.1064 10.4021 14.8154C9.51032 15.1965 8.48968 15.1965 7.59786 14.8154C5.93871 14.1064 4.6325 12.7515 3.77594 11.1796C2.37221 11.7929 1.5 12.6513 1.5 13.6012C1.5 15.4652 4.85786 16.9762 9 16.9762Z"
            fill="#132941"
            />
            <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.75 6.86199C3.75 4.16354 6.10051 1.97601 9 1.97601C11.8995 1.97601 14.25 4.16354 14.25 6.86199C14.25 9.53929 12.5744 12.6635 9.96005 13.7807C9.35061 14.0411 8.64939 14.0411 8.03995 13.7807C5.42562 12.6635 3.75 9.53929 3.75 6.86199ZM9 8.72601C9.82843 8.72601 10.5 8.05444 10.5 7.22601C10.5 6.39759 9.82843 5.72601 9 5.72601C8.17157 5.72601 7.5 6.39759 7.5 7.22601C7.5 8.05444 8.17157 8.72601 9 8.72601Z"
            fill="#132941"
            />
            </svg>
            <span>The Beacon Theatre, New York</span>
            </p>
            <p>
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
            >
            <path
            d="M5.8125 2.35101C5.8125 2.04035 5.56066 1.78851 5.25 1.78851C4.93934 1.78851 4.6875 2.04035 4.6875 2.35101V3.53546C3.608 3.6219 2.89933 3.83404 2.37868 4.35469C1.85803 4.87534 1.64588 5.58402 1.55944 6.66351H16.4406C16.3541 5.58402 16.142 4.87534 15.6213 4.35469C15.1007 3.83404 14.392 3.6219 13.3125 3.53546V2.35101C13.3125 2.04035 13.0607 1.78851 12.75 1.78851C12.4393 1.78851 12.1875 2.04035 12.1875 2.35101V3.48569C11.6886 3.47601 11.1293 3.47601 10.5 3.47601H7.5C6.87072 3.47601 6.31145 3.47601 5.8125 3.48569V2.35101Z"
            fill="#132941"
            />
            <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.5 9.47601C1.5 8.84674 1.5 8.28746 1.50968 7.78851H16.4903C16.5 8.28746 16.5 8.84674 16.5 9.47601V10.976C16.5 13.8044 16.5 15.2187 15.6213 16.0973C14.7426 16.976 13.3284 16.976 10.5 16.976H7.5C4.67157 16.976 3.25736 16.976 2.37868 16.0973C1.5 15.2187 1.5 13.8044 1.5 10.976V9.47601ZM12.75 10.976C13.1642 10.976 13.5 10.6402 13.5 10.226C13.5 9.8118 13.1642 9.47601 12.75 9.47601C12.3358 9.47601 12 9.8118 12 10.226C12 10.6402 12.3358 10.976 12.75 10.976ZM12.75 13.976C13.1642 13.976 13.5 13.6402 13.5 13.226C13.5 12.8118 13.1642 12.476 12.75 12.476C12.3358 12.476 12 12.8118 12 13.226C12 13.6402 12.3358 13.976 12.75 13.976ZM9.75 10.226C9.75 10.6402 9.41421 10.976 9 10.976C8.58579 10.976 8.25 10.6402 8.25 10.226C8.25 9.8118 8.58579 9.47601 9 9.47601C9.41421 9.47601 9.75 9.8118 9.75 10.226ZM9.75 13.226C9.75 13.6402 9.41421 13.976 9 13.976C8.58579 13.976 8.25 13.6402 8.25 13.226C8.25 12.8118 8.58579 12.476 9 12.476C9.41421 12.476 9.75 12.8118 9.75 13.226ZM5.25 10.976C5.66421 10.976 6 10.6402 6 10.226C6 9.8118 5.66421 9.47601 5.25 9.47601C4.83579 9.47601 4.5 9.8118 4.5 10.226C4.5 10.6402 4.83579 10.976 5.25 10.976ZM5.25 13.976C5.66421 13.976 6 13.6402 6 13.226C6 12.8118 5.66421 12.476 5.25 12.476C4.83579 12.476 4.5 12.8118 4.5 13.226C4.5 13.6402 4.83579 13.976 5.25 13.976Z"
            fill="#132941"
            />
            </svg>
            <span>March 15, 2025 | 7:30 PM</span>
            </p>
              </div>
              </div>
              </div> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ShowCard;
